import React from 'react';
import PropTypes from 'prop-types';

import style from './PartnerFreeToken.module.scss';

const Label = ({ text }) => (
  <span className={style.token}>{text}</span>
);

export default Label;

Label.propTypes = {
  text: PropTypes.string.isRequired,
};
